module.exports = "/_next/static/resources/art1-f25bcc2d5a50d1d262aae1c67875f9b8.jpg";